import { FacturacionCPEService } from './../../services/facturacion-cpe/facturacion-cpe.service';
import { Component} from '@angular/core';
import { LoginService } from 'app/services/login/login.service';
import { Router } from '@angular/router';
import Swal from "sweetalert2";

@Component({
  selector: 'app-facturas',
  templateUrl: './facturas.component.html',
  styleUrls: ['./facturas.component.scss']
})
export class FacturasComponent {

  constructor(private router:Router,private loginService:LoginService,private cpeService :FacturacionCPEService) { }

  clickGuard(){
    this.loginService.clickGuard = true;
  }
  clickGuard2(){
    if(this.cpeService.TipoCambio.length > 0){
       this.loginService.clickGuard = true;
    }else{
      Swal.fire({
        title: "¡Algo salió mal!",
        text:  "Se requiere tipo de cambio ",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false 
    });
      this.goBack();
    }
 }
 goBack(){
  this.loginService.clickGuard = true;
  this.router.navigate(['/facturacion/factura/listado']);
 }

}
